<div class="table-responsive">
  <table class="table table-striped bk-table cdc-delta-table">
    <thead>
      <tr>
        <th scope="col">
          <button type="button" class="cdc-delta-sort" (click)="toggleSort('field_name')">
            Field <span class="cdc-delta-sort-icon" aria-hidden="true">{{ sortIcon('field_name') }}</span>
          </button>
        </th>
        <th scope="col">
          <button type="button" class="cdc-delta-sort" (click)="toggleSort('is_value')">
            Is <span class="cdc-delta-sort-icon" aria-hidden="true">{{ sortIcon('is_value') }}</span>
          </button>
        </th>
        <th scope="col">
          <button type="button" class="cdc-delta-sort" (click)="toggleSort('was_value')">
            Was <span class="cdc-delta-sort-icon" aria-hidden="true">{{ sortIcon('was_value') }}</span>
          </button>
        </th>
        <th scope="col">
          <button type="button" class="cdc-delta-sort" (click)="toggleSort('changed_at')">
            Changed <span class="cdc-delta-sort-icon" aria-hidden="true">{{ sortIcon('changed_at') }}</span>
          </button>
        </th>
        <th scope="col">
          <button type="button" class="cdc-delta-sort" (click)="toggleSort('user_display')">
            User <span class="cdc-delta-sort-icon" aria-hidden="true">{{ sortIcon('user_display') }}</span>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of sortedRows">
        <td>{{ row.field_name }}</td>
        <td>{{ row.is_value }}</td>
        <td>{{ row.was_value }}</td>
        <td>
          {{ row.changed_at | momentDate: 'MM/DD/YYYY HH:mm': timezoneId }}
          {{ timezoneLabel }}
        </td>
        <td>{{ row.user_display }}</td>
      </tr>
      <tr *ngIf="!sortedRows?.length">
        <td colspan="5" class="text-muted">No changes recorded.</td>
      </tr>
    </tbody>
  </table>
</div>
